import { loader } from 'graphql.macro'

export default function invoiceJobEmailsQuery ({ dataLoaders, queryKey }) {
  const [, id] = queryKey

  const invoiceJobEmailsSchema = loader('./invoiceJobEmails.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(invoiceJobEmailsSchema, { id })
}
